// 细粒度权限常量与角色映射
export const PERMS = {
  USER_VIEW: 'user:view',
  USER_EDIT: 'user:edit', // 旧的汇总编辑权限（保留向后兼容）
  USER_RESET_PASSWORD: 'user:resetPwd', // 重置密码权限
  USER_CREATE: 'user:create',
  USER_UPDATE: 'user:update',
  USER_DELETE: 'user:delete',
  USER_TOGGLE: 'user:toggle',
  USER_RESET_PWD: 'user:resetPwd',
  ROLE_VIEW: 'role:view',
  ROLE_EDIT: 'role:edit', // 汇总编辑权限
  ROLE_CREATE: 'role:create',
  ROLE_UPDATE: 'role:update',
  ROLE_DELETE: 'role:delete',
  LOG_VIEW: 'log:view',
  // LOG_DELETE: 'log:delete',
  HOTEL_VIEW: 'hotel:view',
  HOTEL_EDIT: 'hotel:edit', // 保留旧汇总权限
  HOTEL_CREATE: 'hotel:create',
  HOTEL_UPDATE: 'hotel:update',
  HOTEL_DELETE: 'hotel:delete',
  HOTEL_TOGGLE: 'hotel:toggle',
  LINEN_VIEW: 'linen:view',
  LINEN_EDIT: 'linen:edit', // 旧的汇总编辑（保持一致策略）
  LINEN_CREATE: 'linen:create',
  LINEN_UPDATE: 'linen:update',
  LINEN_DELETE: 'linen:delete',
  LINEN_IMPORT: 'linen:import',
  // LINEN_MERGE_HOTEL: 'linen:mergeHotel',
  // LINEN_EXPORT: 'linen:export',
  MILEAGE_SUBSIDY_VIEW: 'subsidy:mileage:view', // 里程补贴查看权限
  MILEAGE_SUBSIDY_EDIT: 'subsidy:mileage:edit', // 里程补贴编辑权限
  HANDLING_SUBSIDY_VIEW: 'subsidy:handling:view', // 扛包补贴查看权限
  HANDLING_SUBSIDY_EDIT: 'subsidy:handling:edit', // 扛包补贴编辑权限
  TASK_TEMPLATE_VIEW: 'task:template:view', // 任务模板查看权限
  TASK_TEMPLATE_EDIT: 'task:template:edit', // 任务模板编辑权限
  TASK_MONITOR_VIEW: 'task:monitor:view', // 任务监控查看权限
  TASK_HANDOVER_VIEW: 'task:handover:view', // 交接单查看权限
  TASK_EXCEPTION_VIEW: 'task:exception:view', // 异常记录查看权限
  TASK_EXCEPTION_HANDLE: 'task:exception:handle', // 异常记录处理权限
  REPORT_BUSINESS_VIEW: 'report:business:view',
  COST_WARNING_RECORD_VIEW: 'report:costWarning:record:view',
  COST_WARNING_RECORD_EDIT: 'report:costWarning:record:edit',
  COST_WARNING_THRESHOLD_VIEW: 'report:costWarning:threshold:view',
  COST_WARNING_THRESHOLD_EDIT: 'report:costWarning:threshold:edit',
  APPROVAL_FLOW_CONFIG_VIEW: 'approval:config', // 审批配置权限（配置多级流程）
  APPROVAL_FLOW_CONFIG_EDIT: 'approval:config', // 审批配置权限（配置多级流程）
  APPROVAL_RECORDS_VIEW: 'approval:records:view', // 查看审批申请列表与详情
  APPROVAL_RECORDS_EDIT: 'approval:records:edit', // 编辑审批申请
  SALARY_VIEW: 'salary:view', // 薪资查看权限
  SALARY_CALCULATE: 'salary:calculate', // 重新计算薪资
  TASK_REMINDER_CONFIG_VIEW: 'task:reminderConfig:view', // 任务定时提醒配置查看权限
  TASK_REMINDER_CONFIG_EDIT: 'task:reminderConfig:edit', // 任务定时提醒配置编辑权限
  HOTEL_LINEN_VIEW: 'hotel:linen:view', // 酒店与布草关联查看权限
  HOTEL_LINEN_EDIT: 'hotel:linen:edit', // 酒店与布草关联编辑权限
} as const;
export type PermissionKey = keyof typeof PERMS;
export type Permission = (typeof PERMS)[PermissionKey];
